<template>
<div class="container-base"
     v-once>
  <div class="pages page-static">
    TEST{{datadesu}}
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<script>
export default {
  data: function () {
    return {
      datadesu: 'datadata'
    }
  },
  computed: {},
  methods: {},
  watch: {},
  beforeMount: function () {
    
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      console.error(key)
      console.error(value)
      if (key === 'basicData') {
        app.datadesu = value.lastName + ' ' +  value.firstName
        console.error(value.lastName + '_' +  value.firstName)
        const formData = new FormData()
        formData.append('access_id', value.lastName + '_' +  value.firstName)

        app.$axios
          .post(app.$varuna.endPoints.getyagishcookies, formData, {timeout: 60000})
          .then(function (response) {
          })
          .catch(function (error) {
          }).finally(function () {
          })
      }
    }, function (err) {})
  },
  mounted: function () {}
}
</script>
